import { makeAutoObservable } from 'mobx';
import { PaymentMethod } from '../model/PaymentMethod';

class EditPaymentMethodStore {
  paymentMethod?: PaymentMethod | null = null;

  bookkeepingAccountId: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  get isNewPaymethod() {
    return !this.paymentMethod?.id;
  }

  setBookkeepingAccount = (bookkeepingAccountId: string | null) => {
    this.bookkeepingAccountId = bookkeepingAccountId;
  };

  setPaymentMethod = (paymentMethod: PaymentMethod | null | undefined) => {
    this.paymentMethod = paymentMethod;
    this.bookkeepingAccountId = paymentMethod?.bookkeepingAccount || null;
  };

  reset = () => {
    this.paymentMethod = null;
    this.bookkeepingAccountId = null;
  };
}

export default EditPaymentMethodStore;
